export enum CanonicalPurpose {
  ANALYTICS = 'analytics',
  BEHAVIORAL_ADVERTISING = 'behavioral_advertising',
  DATA_BROKING = 'data_broking',
  EMAIL_MKTG = 'email_mktg',
  ESSENTIAL_SERVICES = 'essential_services',
  MAIL_MKTG = 'mail_mktg',
  PERSONALIZATION = 'personalization',
  PROD_ENHANCEMENT = 'prod_enhancement',
  SMS_MKTG = 'sms_mktg',
  TELE_MKTG = 'tele_mktg',
}

export const CanonicalPurposeName: Record<CanonicalPurpose, string> = {
  [CanonicalPurpose.ANALYTICS]: 'Analytics',
  [CanonicalPurpose.BEHAVIORAL_ADVERTISING]: 'Behavioral Advertising',
  [CanonicalPurpose.DATA_BROKING]: 'Data Broking',
  [CanonicalPurpose.EMAIL_MKTG]: 'Email Marketing',
  [CanonicalPurpose.ESSENTIAL_SERVICES]: 'Essential Services',
  [CanonicalPurpose.MAIL_MKTG]: 'Mail Marketing',
  [CanonicalPurpose.PERSONALIZATION]: 'Personalization',
  [CanonicalPurpose.PROD_ENHANCEMENT]: 'Product Enhancement',
  [CanonicalPurpose.SMS_MKTG]: 'SMS Marketing',
  [CanonicalPurpose.TELE_MKTG]: 'Telemarketing',
}
